<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
  <p style="color: white">Procesando</p>
</ngx-spinner>

<div class="card card-outline card-primary">
  <div class="card-header text-center">
    <a [routerLink]="['/']" class="h1">
      <img src="./assets/img/imgLogin.png" alt="MSA" style="height: 50px;" />
    </a>
  </div>

  <div class="card-body">
    <ng-container *ngIf="!showQrSetup && !showCodeField">
      <p class="login-box-msg">Ingresa tus credenciales</p>

      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="input-group mb-3">
          <input formControlName="username" type="text" class="form-control" placeholder="Usuario" />
          <div class="input-group-append">
            <div class="input-group-text"><span class="fas fa-envelope"></span></div>
          </div>
        </div>

        <div class="input-group mb-3">
          <input formControlName="password" type="password" class="form-control" placeholder="Password" />
          <div class="input-group-append">
            <div class="input-group-text"><span class="fas fa-lock"></span></div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <pf-button [type]="'submit'" [block]="true" [loading]="isAuthLoading"
              [disabled]="isAuthLoading || loginForm.invalid">
              Ingresar
            </pf-button>
          </div>
        </div>
      </form>
    </ng-container>

    <div *ngIf="showQrSetup" class="mt-3 text-center">
      <p>Escanea el siguiente código QR con tu app Authenticator:</p>
      <img [src]="qrUrl" alt="Código QR 2FA" />
      <p class="mt-3">Después de escanear, ingresa el primer código:</p>
      <input [(ngModel)]="codigo2FA" maxlength="6" placeholder="123456" class="form-control w-50 mx-auto text-center" />
      <button class="btn btn-primary mt-2" (click)="activar2FA()" [disabled]="isAuthLoading">Activar 2FA</button>
    </div>

    <div *ngIf="showCodeField" class="mt-4 text-center">
      <p>Ingresa el código generado por tu app Authenticator:</p>
      <input [(ngModel)]="codigo2FA" maxlength="6" placeholder="123456" class="form-control w-50 mx-auto text-center" />
      <button class="btn btn-success mt-2" (click)="validar2FA()" [disabled]="isAuthLoading">Validar</button>
    </div>

    <div *ngIf="errorMsg" class="alert alert-danger mt-3">
      {{ errorMsg }}
    </div>
  </div>
</div>
